export default __webpack_public_path__ + "static/media/dep1_7.de0ad33d.jpeg";